import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const receiptRequestBusinessObjectEnum = createEnum({
    VEHICLE: ['vehicle', '车辆业务', 'blue'],
    NON_VEHICLE: ['non_vehicle', '非车辆业务', 'default'],
});
export const RECEIPT_REQUEST_BUSINESS_OBJECTS = enumValues(receiptRequestBusinessObjectEnum);
export const RECEIPT_REQUEST_BUSINESS_OBJECT_LABEL_MAP = enumLabelMap(receiptRequestBusinessObjectEnum);
export const receiptRequestStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    RECEIVING: ['receiving', '确认收款中', 'processing'],
    FULLY_RECEIVED: ['fully_received', '全部收款', 'cyan'],
    PARTIALLY_RECEIVED: ['partially_received', '部分收款', 'blue'],
    NOT_RECEIVED: ['not_received', '未到账', 'red'],
});
export const RECEIPT_REQUEST_STATUSES = enumValues(receiptRequestStatusEnum);
export const RECEIPT_REQUEST_STATUS_LABEL_MAP = enumLabelMap(receiptRequestStatusEnum);
export const receiptRequestActionEnum = createEnum({
    DRAFT: ['draft', '保存草稿', 'default'],
    SUBMIT: ['submit', '提交', 'blue'],
});
export const RECEIPT_REQUEST_ACTIONS = enumValues(receiptRequestActionEnum);
export const RECEIPT_REQUEST_ACTION_LABEL_MAP = enumLabelMap(receiptRequestActionEnum);
//# sourceMappingURL=receipt-request.js.map